import React from 'react';
import { Link } from 'react-router-dom';
import LoadingCell from '../../../../../ui/table/cells/loadingCell/loadingCell';
import { Tooltip } from '@progress/kendo-react-tooltip';

import './agreementNameCell.scss';

const AgreementNameCell = (props) => {
  if (props.rowType === 'groupHeader') {
    return null;
  }

  if (props.dataItem[props.field] === undefined) return <LoadingCell />;

  return (
    <td className='agreement-name-cell' style={{ width: props.width }}>
      <Tooltip anchorElement='target'>
        <div className='agreement-name-wrapper'>
          <Link to={`/agreements/${props.dataItem.agreementId}`} state={props.dataItem}>
              <span title={props.dataItem[props.field]}>
                {props.dataItem[props.field]}
              </span>
          </Link>
        </div>
      </Tooltip>
    </td>
  );
};

export default AgreementNameCell;
